export const DOMAIN_SCRIPT_GUIDE_EVENTS = {
    FORM_UNSAVED_UPDATE: 'formUnsavedUpdate',
} as const;
